module.exports = __webpack_public_path__ + "static/media/ky.2389d394.svg";